import { Component, OnInit,Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute,NavigationEnd,NavigationStart } from '@angular/router';
import { RoutingService } from 'src/app/services/routingService/routing.service';
import { StorageService } from 'src/app/services/storage.service';
import { UserService } from 'src/app/services/userService/user.service';
import { JwtHelperService } from '@auth0/angular-jwt';

@Component({
  selector: 'app-direct-login',
  templateUrl: './direct-login.component.html',
  styleUrls: ['./direct-login.component.scss']
})
export class directLiginComponent implements OnInit {

  @Output() tokenShare = new EventEmitter();
  constructor(
    private route: ActivatedRoute,
    private storageService: StorageService,
    private userService: UserService,
    private routers: Router,
    private router: RoutingService,
    private jwthelper: JwtHelperService,
  ) { }

  ngOnInit() {
    let status =  this.route.snapshot.queryParams['status']
    let access_token =  this.route.snapshot.queryParams['access_token']
    if(access_token && status == 'success'){            
      this.storageService.setData('access_token', this.route.snapshot.queryParams['access_token']);

      setTimeout(() => {
        this.router.nextStep();
      }, 1000);      
      this.tokenShare.emit(true);
      this.userService.onUserLoginStateChange();    
    }
  }

}
